import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Name from './utils/Name.js';

// import components
import Header from './components/Header';
import BannerIA from './components/BannerIA';
import Slider from './components/Slider.jsx';
import Form from './components/Form';
import Footer from './components/Footer';
import { root } from './utils/Path';
import Chatbot from './components/Chatbot.jsx';

const assetsIA = './assets/images/ia/';

createRoot(document.getElementById('ia')).render(
  <StrictMode>
    <Header active={"Innovación & Servicios"} />
    <BannerIA
      phrase={'Mejora tu xxxx con Inteligencia Artificial'}
      content={[
        'Eficiencia',
        'Productividad',
        'Creatividad',
        'Seguridad'
      ]} />
    <section className='compressed dark big-gap'>
      <h2>Innovación en IA</h2>
      <p className='stretch'>En {Name}, ofrecemos un conjunto de soluciones de IA diseñadas para transformar y optimizar los procesos de su negocio.</p>
    </section>

    <section className='compressed'>
      <h2 data-aos="fade-up">Soluciones de IA</h2>
      <div className="c2">
        <p data-aos="fade-right">Nuestras innovadoras Soluciones de <strong>Inteligencia Artificial</strong>, están diseñadas para transformar diversos sectores y optimizar procesos clave en sus negocios. Desde asistentes digitales avanzados, que incluyen chatbots, análisis de sentimientos y asistentes por voz, hasta sofisticadas aplicaciones de visión artificial en seguridad, salud, retail y atención al cliente predictiva, estamos comprometidos en llevar sus operaciones al siguiente nivel.</p>
        <p data-aos="fade-left">Estas soluciones se adaptan a diversas industrias, incluyendo seguros, banca, atención médica, manufactura, ventas y marketing, logística y transporte. Ya sea para mejorar la seguridad en aeropuertos, detectar retraso en una fila para una mejor experiencia de servicio al cliente, o gestionar inventarios en tiempo real, nuestras tecnologías de IA están preparadas para ofrecer resultados tangibles y mejorar la eficiencia de su empresa.</p>
      </div>
      <div className="exposer inner c2">
        <div className="card-expo flow" data-aos="fade-right">
          <img loading="lazy" src={`${assetsIA}development.webp`} alt='Cluster dedicado para Inteligencia Artificial' aria-label='Cluster dedicado para Inteligencia Artificial' title='Cluster dedicado para Inteligencia Artificial' />
          <div>
            <h3>Desarrollo Personalizado</h3>
            <p>Creamos aplicaciones de IA a medida, adaptadas a las necesidades específicas de cada sector empresarial.</p>
          </div>
        </div>
        <div className="card-expo flow" data-aos="fade-left">
          <img loading="lazy" src={`${assetsIA}consultoria.webp`} alt='Inteligencia artificial en la medicina' aria-label='Inteligencia artificial en la medicina' title='Inteligencia artificial en la medicina' />
          <div>
            <h3>Consultoría IA</h3>
            <p>Asesoramos en la implementación de inteligencia artificial para optimizar procesos y aumentar la productividad.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="compressed dark">
      <h2 data-aos="fade-in">Nuestras Soluciones IA</h2>
      <div className="exposer inner" data-aos="fade-up">
        <div className="card-expo start flow">
          <img loading="lazy" src={`${assetsIA}asistente.webp`} alt='Inteligencia artificial inmersa dentro de interfaz grafica' aria-label='Inteligencia artificial inmersa dentro de interfaz grafica' title='Inteligencia artificial inmersa dentro de interfaz grafica' />
          <div>
            <div>
              <h3>Asistente Digital</h3>
              <p>
                <li>ChatBot</li>
                <li>Análisis de Sentimiento</li>
                <li>Asistente por Voz</li>
                <li>RPA</li>
              </p>
            </div>
          </div>
        </div>
        <div className="card-expo start flow">
          <img loading="lazy" src={`${assetsIA}vision-artificial.webp`} alt='Ciudad Inteligente' aria-label='Ciudad Inteligente' title='Ciudad Inteligente' />
          <div>
            <div>
              <h3>Visión Artificial</h3>
              <p>
                <li>Seguridad y Vigilancia</li>
                <li>Salud</li>
                <li>Retail</li>
              </p>
            </div>
          </div>
        </div>
        <div className="card-expo start flow">
          <img loading="lazy" src={`${assetsIA}big-data.webp`} alt='Imagen alusiva al análisis estadístico' aria-label='Imagen alusiva al análisis estadístico' title='Imagen alusiva al análisis estadístico' />
          <div>
            <div>
              <h3>Análisis Predictivo</h3>
              <p>
                <li>Ventas</li>
                <li>Optimización de Inventario</li>
                <li>Atención al Cliente Automatizada</li>
                <li>Prevención de Fraudes</li>
                <li>Análisis de Precios Competitivos</li>
                <li>Recomendación de Productos</li>
                <li>Análisis de Satisfacción del Cliente</li>
                <li>Logística Inteligente</li>
                <li>Automatización de Procesos</li>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* <section className='fw' data-aos="fade-up">
      <h2>Opiniones de nuestros clientes</h2>
      <Slider content={
        <div>
          <div className='witness stars5'>
            <p>Gracias a la solución de HPE, hemos optimizado nuestros procesos de IA y mejorado la eficiencia operativa en poco tiempo.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Ana López</span>
              <p>Barcelona</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
        </div>
      } customClass={'compressed'} />
    </section> */}
    
    <Form
      title={'Soluciones Inteligencia Artificial'}
      content={'Construimos soluciones innovadoras con inteligencia artificial, aumentando tu rendimiento y el de tus recursos.'}
      img={{ src: `${assetsIA}contacto.webp`, alt: 'Hombre elegante jugando ajedrez contra un robot' }}
      form={[
        {
          label: 'Nombre contacto',
          type: 'text',
          id: 'nombre',
          placeholder: 'Ingrese su nombre aquí'
        },
        {
          label: 'Correo electrónico',
          type: 'email',
          id: 'email',
          placeholder: 'Ingrese su correo aquí'
        },
        {
          label: 'Mensaje',
          type: 'textarea',
          id: 'mensaje',
          placeholder: 'Déjanos un mensaje aquí'
        },
        {
          label: 'Enviar Mensaje',
          type: 'submit',
          id: 'submit',
        }
      ]}
      redirect={`${root}servicios-ia.html`}
    />
    <Footer />
    <Chatbot />
  </StrictMode>
)